export class Doctor {
    $key : string;
    vote : number;
    ipadress : string;
    code: string;
}
